import {Dialog, Toast} from 'vant';
import {UserLeaveStatusEnum} from "@/common/UserLeaveStatusEnum";
import typeUtils from "@/common/typeUtils";

const _BeforeLoginUrlKeyName = 'beforeLoginUrl';
const _OpenIdKeyName = 'openId';

let commonUtils = {
    //图片后缀列表
    imgExtensions: ['jpg', 'jpeg', 'png', 'ico', 'bmp'],
    //获取路径文件后缀
    getExtension: function (url) {
        if (url == null || url.trim() == '') {
            return '';
        }
        var strs = url.split(".");
        return strs[strs.length - 1];
    },
    //检查文件后缀是否是图片
    checkIsImage: function (extension) {
        for (var item of this.imgExtensions) {
            if (extension.toLowerCase() == item) {
                return true;
            }
        }
        return false;
    },
    //检查URL指向的是不是图片
    checkUrlIsImage: function (url) {
        var extension = this.getExtension(url);
        var isImage = this.checkIsImage(extension);
        return isImage;
    },
    //判断指定字符串是否在数组中
    strInArr: function (str, arr) {
        if (str == null || arr == null || arr.length <= 0) {
            return false;
        }
        for (var item of arr) {
            if (item == str) {
                return true;
            }
        }
        return false;
    },
    //克隆对象
    cloneObj: function (obj) {
        var result = JSON.parse(JSON.stringify(obj));
        return result;
    },

    copyValue(target, src) {
        for (let prop in target) {
            if (src.hasOwnProperty(prop)) {
                target[prop] = src[prop];
            }
        }
        return target;
    },

    /**
     * 返回日期字符串
     * @param dateTimeStr 日期时间字符串 如2020-02-09 00:00:00
     * @returns {string} 如2020-02-09
     */
    getDateStr(dateTimeStr) {
        if (dateTimeStr && dateTimeStr.length === 19) {
            return dateTimeStr.substr(0, 10);
        } else {
            return dateTimeStr;
        }
    },
    /**
     * 判断是否在微信浏览器中打开
     */
    isWeiXin() {
        return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    },
    /**
     * 微信SDK初始化
     * @param thisApp
     */
    initWeiXinSdk(thisApp) {
        return new Promise((resolve, reject) => {
            if (!this.isWeiXin()) {
                reject('请使用微信访问!');
                return;
            }
            if(window.globalConfig.isThirdLogin){
                resolve();
                return;
            }
            wx.error((res) => {
                // console.log("wx.config报错",res);
                // thisApp.$error("wx.config报错" + JSON.stringify(res) );
                let errMsg = '';
                switch (res.errMsg) {
                    case 'config:require subscribe':
                        errMsg = '请先关注该微信公众号！';
                        break
                    default:
                        errMsg = '微信JSSDK初始化失败！' + JSON.stringify(res);
                        break
                }
                Dialog.alert({
                    // res.errMsg
                    message: errMsg,
                })
                reject(errMsg);
            });
            wx.ready(function(){
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                wx.showMenuItems({
                    menuList: ["menuItem:profile", "menuItem:addContact"] // 要显示的菜单项，所有menu项见附录3
                });
                wx.hideMenuItems({ // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                    menuList: ["menuItem:share:qq", "menuItem:share:weiboApp", "menuItem:share:facebook",
                        "menuItem:share:QZone", "menuItem:openWithQQBrowser", "menuItem:openWithSafari", "menuItem:share:brand", "menuItem:share:email"]
                });
                resolve();
            });
            thisApp.$get("/wechat/getConfig", {url: window.location.href}).then(res => {
                let data = res.data;
                // console.log("data ", data)
                let config = {
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.appId, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: data.signature,// 必填，签名
                    jsApiList: data.jsApiList // 必填，需要使用的JS接口列表
                }
                // console.log("d==>", config);
                wx.config(config);
            });
        });
    },
    wxGetLocation(){
        return new Promise((resolve, reject) => {
            if(this.isWeiXin() && wx) {
                wx.getLocation({
                    type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                    success: (res) => {
                        // var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
                        // var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
                        // var speed = res.speed; // 速度，以米/每秒计
                        // var accuracy = res.accuracy; // 位置精度
                        resolve(res);
                    },
                    error: (err) => {
                        reject(err);
                    }
                });
            }else {
                this.showToast('请使用微信访问!');
                reject();
            }
        });
    },
    /**
     * 跳转到登录
     * @param {String} type 登录类型： 1 管局端， 2 企业端
     * @param {boolean} isBack 登录后是否跳转到登录前的URL， 默认是
     */
    goLoginPage(type = null, isBack = true) {
        // 登录跳转前，先保存当前访问的地址
		if (isBack) {
			this.setBeforeLoginUrl(window.location.href);
		}
		if (this.isWeiXin()) {
			let url = this.getLoginUrl(type);
			this.goPage(url, true);
		} else {
			this.showAlertOpenInWeiXin();
		}
		// console.log("goLoginPage");
    },
    /**
     * 获取登录页URL
     * @param {String} type 登录类型： 1 管局端， 2 企业端
     * @param {String} openId 指定OpenID登录
     * @param {Object} extParams 其它扩展参数
     * @returns {String}
     */
    getLoginUrl(type = null, openId = null, extParams = null) {
        let params = {};
        if (type) {
            params.type = type;
        }
        if (openId) {
            params.openId = openId;
        }
        if (extParams) {
            Object.assign(params, extParams);
        }
        return this.getAbsoluteUrl('#/wx', params);
    },
    /**
     * 登录跳转前的页面
     * @returns {string}
     */
    getBeforeLoginUrl() {
        return this.getCookie(_BeforeLoginUrlKeyName);
    },
    /**
     * 保存登录跳转前的页面
     * @param url
     */
    setBeforeLoginUrl(url) {
        this.setCookie(_BeforeLoginUrlKeyName, url, 10);
    },
    /**
     * 清除登录跳转前的页面
     */
    clearBeforeLoginUrl() {
        this.setBeforeLoginUrl('');
    },
    /**
     * 跳转到登录前的URL，如果不存在登录前的URL，则返回false
     * @returns {boolean}
     */
    goBeforeLoginPage() {
        // 先判断是否在存登录前页面
        let beforeLoginUrl = this.getBeforeLoginUrl();
        if (beforeLoginUrl) {
            // 登录回返回登录前的页面
            this.clearBeforeLoginUrl();
            this.goPage(beforeLoginUrl, true);
            return true;
        }
        return false;
    },
    showAlertOpenInWeiXin() {
        // this.goPage('./index.html?openId=1011', true); // 开发调试使用

        Dialog.alert({
            message: '登录失败，请使用微信浏览',
        }).then(() => {
            // on close
        });
    },
    // goHomePage(){
    // 	window.location.href = './#/home';
    // },
    getPath() {
        let pathname = window.location.pathname;
        return pathname.substring(0, pathname.lastIndexOf('/')) + '/';
    },
    setCookie(cname, cvalue, seconds, path) {
        let expires = '';
        if (typeUtils.isNumber(seconds)) {
            let d = new Date()
            d.setTime(d.getTime() + (seconds * 1000))
            expires = 'expires=' + d.toUTCString()
        }
        if (!path) {
            path = this.getPath();
        }
        document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=' + path
    },
    getCookie(cname) {
        let name = cname + '='
        let ca = document.cookie.split(';')
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim()
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length)
        }
        return ''
    },
    isLocalStorage() {
        if (window.localStorage) {
            return true
        } else {
            return false;
        }
    },
    getPathKey(key) {
        return key + '_' + this.getPath();
    },
    setStorage(key, value) {
        if (value) {
            window.localStorage.setItem(this.getPathKey(key), JSON.stringify(value));
        } else {
            window.localStorage.removeItem(this.getPathKey(key));
        }
    },
    getStorage(key) {
        let val = window.localStorage.getItem(this.getPathKey(key));
        if (val) {
            return JSON.parse(val);
        } else {
            return null;
        }
    },
    /**
     * 获取显示的错误信息
     * @param err
     * @returns {string}
     */
    getErrMsg(err) {
        let msg = err.errorMsg || err.msg;
        if (!msg && err.response) {
            msg = err.response.statusText + ' [' + err.response.status + '] ' + err.response.data;
        }
        return msg;
    },
    /**
     *
     * @param {Vue} thisApp
     * @param {String} path
     * @param {Object} params
     * @param {boolean} isReplace
     */
    goRouterPage(thisApp, path, params = null, isReplace = false) {
        if (isReplace) {
            thisApp.$router.replace({path: path, query: params});
        } else {
            thisApp.$router.push({path: path, query: params});
        }

        // thisApp.$router.push("/")
    },
    goPage(url, isRedirect = false) {
        if (isRedirect) {
            // self.location.href = url;
            window.location.replace(url);
        } else {
            window.location.href = url;
        }
    },
    /**
     * 获取当前Url的参数
     */
    queryParams() {
        const patt = window.location.href.match(/\?([^#]*)?/i);
        let params = {};
        if (patt && patt[1]) {
            const queryParams = patt[1].split('&');
            let temp;
            const reg = /([^=]+)=([^&]*)/i;
            for (let p of queryParams) {
                if (p) {
                    temp = p.match(reg);
                    params[temp[1]] = temp[2];
                }
            }
        }
        return params;
    },
    /**
     * 获取当前项目的城市
     * @returns {Promise<cityCode>}
     */
    getCity() {
        return new Promise((resolve) => {
            this.getWebSiteInfo(window.VmApp).then((data) => {
                resolve({
                    "cityCode": data.cityCode,
                    "mapZoom": data.mapZoom,
                    "mapCenterLngLat": data.mapCenterLngLat
                });
            })
            // resolve('0769dg') //区号
            //resolve('0753mz')   //梅州区号
        });
    },
    /**
     * 获取当前用户openId
     * @returns {string}
     */
    getOpenId() {
        return this.getCookie(_OpenIdKeyName);
    },
    /**
     * 设置用户openId，有效时间7200秒(2小时间)
     * @param openId
     */
    setOpenId(openId) {
        if (!openId || openId === 'null') {
            this.setCookie(_OpenIdKeyName, '', -1);
        }else {
            this.setCookie(_OpenIdKeyName, openId, 7200);
        }
    },
    /**
     * 获取网站信息
     * @param thisApp
     * @returns {Promise<{qrLogin,pswLogin,cityCode,siteTitle,adminLoginFooter,bigChartTitle}>}
     */
    getWebSiteInfo(thisApp, config = {}, useStorageCache = false) {
        // console.log("getWebSiteInfo");
        return new Promise((resolve) => {
            if (window.webSiteInfo) {
                resolve(window.webSiteInfo);
            } else {
                if (useStorageCache) {
                    const webSiteInfoCache = this.getStorage("siteInfo");
                    if (webSiteInfoCache) {
                        window.webSiteInfo = webSiteInfoCache;
                        resolve(webSiteInfoCache);
                        return;
                    }
                }
                let defaultData = {
                    qrLogin: 0,
                    pswLogin: 1,
                    cityCode: '',
                    siteTitle: "邮政管理局安全监管平台",
                    adminLoginFooter: "技术支持：广州万博软件科技有限公司",
                    bigChartTitle: "邮政业一张图",
                    "mapZoom": "9",
                    "mapCenterLngLat": "116.182563,24.269714"
                };
                // console.log("aaaaaaaa==>", thisApp);
                thisApp.$get('/dic/getSiteInfo', {}, config, 2).then(({data}) => {
                    window.webSiteInfo = this.copyValue(defaultData, data);
                    this.setStorage("siteInfo", window.webSiteInfo);
                    resolve(window.webSiteInfo);
                }).catch(() => {
                    const localSiteInfo = this.getStorage("siteInfo");
                    if (localSiteInfo) {
                        resolve(JSON.parse(localSiteInfo));
                    } else {
                        resolve(defaultData);
                    }
                })
            }
        });
    },
    /**
     *
     * @param {Vue} thisApp
     */
    goBack(thisApp) {
        thisApp.$router.go(-1);
    },
    /**
     * 是否未登录可访问的url
     * @param {String} url
     */
    isNotAuthPage(url) {
        const whiteList = [
            '#/user/register',   // 管局注册
            '#/meeting/meetingValueScanCode/',  // 会议签到
            '#/bind/',  // 企业注册
            '#/myInformation/register',
            '#/protocolClientChoose', //协议客户采集方式
            '#/protocolClientAdd', //协议客户添加
            '#/carCollect/collect', //车辆信息采集
            '#/public/', //车辆信息采集
            '#/download', //下载处理页
            '#/villageIndex'
        ];
        return this.isInWhiteList(url, whiteList);
    },
    /**
     * 是否企业端URL
     * @param url
     * @returns {boolean}
     */
    isClientPage(url) {
        const whiteList = ['/zqtClient.html', '/safetyClient.html'];
        return this.isInWhiteList(url, whiteList);
    },
    /**
     * 是否管局端URL
     * @param url
     * @returns {boolean}
     */
    isAdminPage(url) {
        const whiteList = ['/zqtAdmin.html', '/safetyAdmin.html'];
        return this.isInWhiteList(url, whiteList);
    },
    /**
     * 是否订餐端URL
     * @param url
     * @returns {boolean}
     */
    isOrderPage(url) {
        const whiteList = ['/order.html'];
        return this.isInWhiteList(url, whiteList);
    },
    /**
     * 判断URL是否在白名单中
     * @param {String} url 要匹配的URL
     * @param {Array<string>} whiteList 白名单列表，正则表达式
     * @returns {boolean}
     */
    isInWhiteList(url, whiteList) {
        let reg;
        for (let item of whiteList) {
            reg = new RegExp(item);
            if (reg.test(url)) {
                return true;
            }
        }
        return false;
    },
    /**
     * 获取上传文件的完整路径
     * @param path
     */
    getUploadPathFull(path) {
        let basePath = window.globalConfig.uploadBasePath;
        if (path.startsWith('~')) {
            path = path.substr(1);
        }
        if (basePath) {
            if(basePath.startsWith('/')){
                let url = window.location.href;
                let subIdx = url.indexOf('/');
                if(subIdx>0){
                    url = url.substr(0, subIdx);
                }
                basePath = url + basePath;
            } else if (basePath.startsWith('../')) {
                let url = window.location.href;
                let subIdx = url.lastIndexOf('/');
                if (subIdx > 0) {
                    url = url.substr(0, subIdx);
                    subIdx = url.lastIndexOf('/');
                    if (subIdx > 0) {
                        url = url.substr(0, subIdx);
                    }
                }
                basePath = url + basePath.substr(2);
            } else if (basePath.startsWith('./')) {
                let url = window.location.href;
                let subIdx = url.lastIndexOf('/');
                if (subIdx > 0) {
                    url = url.substr(0, subIdx);
                }
                basePath = url + basePath.substr(1);
            }
            if (basePath.endsWith('/') && path.startsWith('/')) {
                path = path.substr(1);
            }
            return basePath + path;
        } else {
            return path;
        }
    },
    /**
     * 获取后端接口服务的完整地址
     * @param path
     * @returns {string|*}
     */
    getApiPath(path) {
        let basePath = window.globalConfig.basePath;
        if (basePath) {
            if (basePath.endsWith('/') && path.startsWith('/')) {
                path = path.substr(1);
            }
            return basePath + path;
        } else {
            return path;
        }
    },
    /**
     *
     * @param {string} path
     * @param {Object} params
     * @returns {string}
     *       console.log(commonUtils.getAbsoluteUrl('zqtAdmin.html#/user/register', {code: '?1%11'}))
     *       console.log(commonUtils.getAbsoluteUrl('zqtAdmin.html?aa=bb#/user/register', {code: '?1%11'}))
     *       console.log(commonUtils.getAbsoluteUrl('zqtAdmin.html?aa=bb#/user/register?cc=ccc', {code: '?1%11'}))
     *       console.log(commonUtils.getAbsoluteUrl('zqtAdmin.html#/user/register?cc=ccc', {code: '?1%11'}))
     */
    getAbsoluteUrl(path, params = null) {
        let url = window.location.href;
        let subIdx = url.indexOf('?');
        if (subIdx > 0) {
            url = url.substr(0, subIdx);
        }
        subIdx = url.indexOf('#');
        if (subIdx > 0) {
            url = url.substr(0, subIdx);
        }
        subIdx = url.lastIndexOf('/');
        url = url.substr(0, subIdx + 1);
        if (path.startsWith('/')) {
            path = path.substr(1);
        }
        if (params) {
            let paramsStr = '';
            for (let pName in params) {
                paramsStr += `&${pName}=${encodeURIComponent(params[pName])}`;
            }
            // 判断原Url是否有参数,注意#有可能在参数前，或参数后，如 /index.html#/bind?id=XX 或/index.html?id=XX#/bind
            subIdx = path.lastIndexOf('?');
            let joinChar = '?';
            if (subIdx >= 0) {
                // 判断参数后面是否有书签锚点
                subIdx = path.indexOf('#', subIdx);
                if (subIdx === -1) {
                    // 无书签锚点使用&拼接参数
                    joinChar = '&';
                }
            }
            if (paramsStr) {
                path += joinChar + paramsStr.substr(1);
            }
        }
        return url + path;
    },
    getUrl(url, params){
        if (params) {
            let paramsStr = '';
            for (let pName in params) {
                paramsStr += `&${pName}=${encodeURIComponent(params[pName])}`;
            }
            // 判断原Url是否有参数,注意#有可能在参数前，或参数后，如 /index.html#/bind?id=XX 或/index.html?id=XX#/bind
            let subIdx = url.lastIndexOf('?');
            let joinChar = '?';
            if (subIdx >= 0) {
                // 判断参数后面是否有书签锚点
                subIdx = url.indexOf('#', subIdx);
                if (subIdx === -1) {
                    // 无书签锚点使用&拼接参数
                    joinChar = '&';
                }
            }
            if (paramsStr) {
                url += joinChar + paramsStr.substr(1);
            }
        }
        return url;
    },
    ToastText: 'text',
    ToastSuccess: 'success',
    ToastFail: 'fail',
    /**
     *
     * @param {String} msg 文本内容，支持通过\n换行
     * @param {String} type 提示类型，可选值为 text loading success fail html, 默认值 text
     * @param {number} duration 展示时长(ms)，值为 0 时，toast 不会消失, 默认值 3000
     * @returns {Promise>}
     */
    showToast(msg, type = 'text', duration = 3000) {
        return new Promise((resolve) => {
            let options = {
                message: msg,
                type: type,
                duration: duration,
                onClose: () => {
                    resolve();
                }
            }
            Toast(options);
        });
    },
    showToastSuccess(message){
        // Toast.fail(message);
        return this.showToast(message, this.ToastSuccess);
    },
    showToastError(message){
        // Toast.fail(message);
        return this.showToast(message, this.ToastFail);
    },
    /**
     *
     * @param msg
     * @returns {Promise<>}
     */
    showAlert(msg) {
        return new Promise((resolve) => {
            Dialog.alert({
                message: msg,
            }).then(() => {
                // on close
                resolve();
            });
        });
    },
    showConfirm(title, message){
        return Dialog.confirm({
            title: title,
            message: message,
        })
          // .then(() => {
          //     // on confirm
          // })
          // .catch(() => {
          //     // on cancel
          // });
    },
    /**
     * 判断是否是word格式文件，如果是，后台请求成pdf,不是就返回路径
     * @param filePath 文件的所在路径
     * @param _this  附件所在位置的对象
     * @returns {Promise<any>}
     */
    isShowPdf(filePath, _this) {
        let suffix = filePath.substr(filePath.lastIndexOf("."), filePath.length);
        // console.log("suffix ",suffix);
        // let pdfHtml = "/pdfViewer.view?pdfUrl=";
        // let host=window.location.protocol+"//"+window.location.host;
        return new Promise((resolve) => {
            switch (suffix) {
                case ".doc":
                    _this.$get("/common/wordToPdf", {filePath: filePath}).then(res => {
                        // console.log(res);
                        resolve(this.getUploadPathFull(res.data));
                    })
                    break;
                case ".docx":
                    _this.$get("/common/wordToPdf", {filePath: filePath}).then(res => {
                        // console.log(res);
                        resolve(this.getUploadPathFull(res.data));
                    })
                    break;
                case ".pdf":
                    resolve(this.getUploadPathFull(filePath));
                    break;
                default:
                    resolve(this.getUploadPathFull(filePath));
            }
        });
    },
    isPreviewFile(extName){
        switch (extName.toLowerCase()){
            case 'pdf':
                return 1;
            case 'doc':
            case 'docx':
            case 'ppt':
            case 'pptx':
            case 'xls':
            case 'xlsx':
                return 2;
            default:
                return 0;
        }
    },
    startDownload(url, fileName){
        const downloadElement = document.createElement('a')
        downloadElement.href = url
        downloadElement.download = fileName // 下载后文件名
        // downloadElement.target = '_blank' // 加这个后，预处理时间长会被浏览器拦截，如果下载异常，当前页会显示异常页
        downloadElement.type = 'application/octet-stream'
        document.body.appendChild(downloadElement)
        downloadElement.click() // 点击下载
        document.body.removeChild(downloadElement) // 下载完成移除元素
    },
    /**
     * 产生随机整数，包含下限值，但不包括上限值
     * @param {Number} lower 下限
     * @param {Number} upper 上限
     * @return {Number} 返回在下限到上限之间的一个随机整数
     */
    random(lower, upper) {
        return Math.floor(Math.random() * (upper - lower + 1)) + lower;
    },
    /**
     * 获取客户端标识
     */
    getPid() {
        let pid = this.getStorage('pid');
        if(!pid){
            pid = (new Date()).getTime() + '.' + this.random(100, 999);
            this.setStorage('pid', pid);
        }
        return pid;
    },
    getUserLeaveStatus(){
        // 加入待审(2000), 加入失败(2001), 在职(2002), 离职(2003)
        return  new UserLeaveStatusEnum().add("audit",2000,"加入待审")
            .add("fail",2001,"加入失败")
            .add("onJob",2002,"在职")
            .add("leave",2003,"离职") ;
    },
    /**
     * 判断是否已经引入某个css或是js
     * alert(isInclude("abc.js"));
     * alert(isInclude("efg.css"));
     * @param name
     * @returns {boolean}
     */
    isInclude(name) {
        let js = /js$/i.test(name);
        let es = document.getElementsByTagName(js ? 'script' : 'link');
        for (let i = 0; i < es.length; i++)
            if (es[i][js ? 'src' : 'href'].indexOf(name) !== -1) return true;
        return false;
    },
    /**
     * 动太引入高德地图
     * @returns {Promise<unknown>}
     */
    requireAMap(){
        return new Promise((resolve) => {
            if(this.isInclude('webapi.amap.com/ui/1.0/main.js')){
                resolve();
            }else {
                // 高德地图异步加载
                loadScript("https://webapi.amap.com/maps?v=1.4.15&key=554692e70af416df306c23de78ac76bc&plugin=AMap.MarkerClusterer,Map3D,AMap.Geocoder,AMap.DistrictLayer,AMap.Scale,AMap.ToolBar,AMap.DistrictSearch,AMap.Pixel,AMap.Heatmap", function () {
                    loadScript("https://webapi.amap.com/ui/1.0/main.js", function () {
                        loadScript("https://webapi.amap.com/ui/1.0/ui/overlay/SimpleMarker.js", function (){
                            resolve();
                        })
                    })
                });
            }
        });
    },
    initAMap(containerId='container', lng, lat, zoom){
        return new Promise((resolve, reject) => {
            try{
                this.requireAMap().then(() => {
                    let map = new AMap.Map(containerId, {
                        resizeEnable: true,
                        center: [lng, lat],
                        zoom: zoom
                    });
                    resolve(map);
                });
            }catch (ex){
                this.showToastError(this.getErrMsg(ex));
                reject(ex);
            }
        });
    },
    getCurrentPositionByAMap(noGeoLocation){
        const _this = this;
        // console.log('getCurrentPositionByAMap')
        return new Promise((resolve, reject) => {
            if(!AMap) {
                // commonUtils.showAlert('请先引入高德地图').then(()=>{
                //
                // });
                reject('请先引入高德地图');
                return;
            }
            if(typeof noGeoLocation == 'undefined'){
                // alert('auto set noGeoLocation')
                noGeoLocation = 1;
                if(window.location.href.startsWith('https')){
                    noGeoLocation = 0;
                }
            }
            // alert('noGeoLocation:'+ noGeoLocation);
            AMap.plugin('AMap.Geolocation', function() {
                let geolocation = new AMap.Geolocation({
                    enableHighAccuracy: true,//是否使用高精度定位，默认:true
                    noGeoLocation: noGeoLocation, // 是否禁止使用浏览器Geolocation定位，默认值为0，可选值0-3 0: 可以使用浏览器定位 1: 手机设备禁止使用浏览器定位 2: PC上禁止使用浏览器定位 3: 所有终端禁止使用浏览器定位
                    timeout: 15000,          //超过10秒后停止定位，默认：5s
                    // buttonPosition:'RB',    //定位按钮的停靠位置
                    // buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                    zoomToAccuracy: false,   //定位成功后是否自动调整地图视野到定位点
                    showButton:false,   // 是否显示定位按钮
                    showMarker: false,        //定位成功后在定位到的位置显示点标记，默认：true
                    showCircle: false,        //定位成功后用圆圈表示定位精度范围，默认：true
                    panToLocation: false,     //定位成功后将定位到的位置作为地图中心点，默认：true
                });
                // map.addControl(geolocation);
                geolocation.getCurrentPosition(function(status,result){
                    // alert(status);
                    if(status==='complete'){
                        // onComplete(result)
                        resolve(result);
                    }else{
                        if(noGeoLocation !== 3){
                            _this.getCurrentPositionByAMap(3).then((data2)=>{
                                resolve(data2);
                            }).catch((err)=>{
                                reject(err);
                            })
                        }else {
                            reject(result.message);
                            // onError(result)
                        }
                    }
                });
            });
        });
    },
    //切割坐标字符串并返回
    getLngLat(str) {
        if (str == null) {
            return null;
        }
        let place = str.split(","); //切割经纬度字符串
        return {
            lng: place[0],
            lat: place[1],
        }
    },
    requireMqtt(){
        return new Promise((resolve) => {
            if (this.isInclude('mqtt.min.js')) {
                resolve();
            } else {
                // web_app/public/static/js/mqtt.min.js
                let url = this.getAbsoluteUrl('static/js/mqtt.min.js');
                loadScript(url, function (){
                    resolve();
                })
            }
        });
    },
    // 调用拨号功能
    callPhone(phoneNumber) {
        window.location.href = 'tel:' + phoneNumber;
    },
    /**
     * 文本复制到剪切板
     * @param {*} text
     */
    copyText(text) {
        var tag = document.createElement('input');
        tag.setAttribute('id', 'cp_hgz_input');
        tag.value = text;
        document.getElementsByTagName('body')[0].appendChild(tag);
        document.getElementById('cp_hgz_input').select();
        document.execCommand('copy');
        document.getElementById('cp_hgz_input').remove();
    },

    formatDate(date, fmt) {
      var o = {
        "M+" : date.getMonth()+1, //月份
        "d+" : date.getDate(), //日
        "h+" : date.getHours()%12 == 0 ? 12 : date.getHours()%12, //小时
        "H+" : date.getHours(), //小时
        "m+" : date.getMinutes(), //分
        "s+" : date.getSeconds(), //秒
        "q+" : Math.floor((date.getMonth()+3)/3), //季度
        "S" : date.getMilliseconds() //毫秒
      };
      if(/(y+)/.test(fmt))
        fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
      for(var k in o)
        if(new RegExp("("+ k +")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
      return fmt;
    },
//     //解析定位结果
//     function onComplete(data) {
//     document.getElementById('status').innerHTML='定位成功'
//     var str = [];
//     str.push('定位结果：' + data.position);
//     str.push('定位类别：' + data.location_type);
//     if(data.accuracy){
//         str.push('精度：' + data.accuracy + ' 米');
//     }//如为IP精确定位结果则没有精度信息
//     str.push('是否经过偏移：' + (data.isConverted ? '是' : '否'));
//     document.getElementById('result').innerHTML = str.join('<br>');
// }
// //解析定位错误信息
// function onError(data) {
//     document.getElementById('status').innerHTML='定位失败'
//     document.getElementById('result').innerHTML = '失败原因排查信息:'+data.message;
// }
//     }
};

export default commonUtils;
